import { DEVELOP_GRADES_ROUTER, DEVELOP_ICON_ROUTER, DEVELOP_TEST_ROUTER, DASHBOARD_MEMBER_PROFILE_ROUTER } from "@Router/routerPath";
import { IconsPage } from "@Local/Development/";
import { TestPage } from "@Local/Development";
import { GradesPage } from "@Local/Development";
import { MemberPage } from "@Local/Dashboard/";
import { FRONT_KEY } from "@Constants/frontKey";

export const developerRouter = {
	description: "開發用",
	menuName: "開發專用區",
	frontKey: FRONT_KEY.DEVELOP,
	children: [
		{
			description: "所有SVG圖檔",
			menuName: "所有Icon",
			strict: true,
			path: DEVELOP_ICON_ROUTER,
			href: DEVELOP_ICON_ROUTER,
			as: IconsPage,
			frontKey: FRONT_KEY.DEVELOP_ICONS,
		},
		{
			description: "test",
			menuName: "各種測試",
			strict: true,
			path: DEVELOP_TEST_ROUTER,
			href: DEVELOP_TEST_ROUTER,
			as: TestPage,
			frontKey: FRONT_KEY.DEVELOP_TEST,
		},
		{
			description: "grades",
			menuName: "排名成績單",
			strict: true,
			path: DEVELOP_GRADES_ROUTER,
			href: DEVELOP_GRADES_ROUTER,
			as: GradesPage,
			frontKey: FRONT_KEY.DEVELOP_GRADES,
		},
		{
			description: "會員輪廓",
			menuName: "會員輪廓",
			static: true,
			path: DASHBOARD_MEMBER_PROFILE_ROUTER,
			href: DASHBOARD_MEMBER_PROFILE_ROUTER,
			as: MemberPage,
			frontKey: FRONT_KEY.DEVELOP_MEMBER_PROFILE,
		},
	],
};
